import React from 'react'

// An Admin-proxy session is one where the app is showing another actor's dashboard
// while the original Admin JWT is preserved. MultiLogin sets both of these on proxy-in;
// this is the same signal ProtectedRoute uses to detect a proxy session.
const isAdminProxy = () =>
  Boolean(localStorage.getItem('adminToken')) && Boolean(localStorage.getItem('AdminProxyScreen'))

const ShieldIcon = () => (
  <svg
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
)
const BackIcon = () => (
  <svg
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M19 12H5M11 6l-6 6 6 6" />
  </svg>
)

// Restore the original Admin session and go back to the Admin portal picker.
// The Admin JWT was preserved as `adminToken`; put it back as the active token,
// set the role back to Admin, and drop the proxy marker so AppContent renders the picker.
const returnToAdmin = () => {
  try {
    const adminToken = localStorage.getItem('adminToken')
    if (adminToken) localStorage.setItem('token', adminToken)
    localStorage.setItem('role', 'Admin')
    localStorage.setItem('roles', JSON.stringify(['Admin']))
    localStorage.removeItem('AdminProxyScreen')
  } catch (e) {
    // ignore storage errors
  }
  // Full reload so the whole app re-reads the restored Admin session cleanly.
  window.location.href = '/multiLogin'
}

const ProxyBanner = () => {
  if (!isAdminProxy()) return null
  const viewing = localStorage.getItem('AdminProxyScreen')

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 12,
        padding: '10px 16px',
        marginBottom: 16,
        borderRadius: 12,
        background: '#fff7ed',
        border: '1px solid #fdba74',
        color: '#9a3412',
        fontSize: '0.9rem',
      }}
    >
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10, fontWeight: 600 }}>
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 28,
            height: 28,
            borderRadius: 8,
            background: '#ffedd5',
            color: '#b45309',
            flex: 'none',
          }}
        >
          <ShieldIcon />
        </span>
        <span>
          Admin view: you are viewing the <strong>{viewing}</strong> dashboard.
        </span>
      </span>
      <button
        type="button"
        onClick={returnToAdmin}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 7,
          padding: '8px 14px',
          borderRadius: 8,
          border: 'none',
          background: '#b45309',
          color: '#fff',
          fontWeight: 700,
          fontSize: '0.85rem',
          cursor: 'pointer',
          whiteSpace: 'nowrap',
        }}
      >
        <BackIcon /> Return to Admin Dashboard
      </button>
    </div>
  )
}

export default ProxyBanner
